<template>
  <div class="d-inline-block">
    <v-btn 
      outlined
      color="primary" 
      @click="show_dialog = true" 
      :disabled="value"
      class="rounded-lg text-none font-weight-black shadow-xs"
    >
      <v-icon left small>fas fa-paper-plane</v-icon>
      Prueba de Conexión
    </v-btn>

    <v-dialog v-model="show_dialog" max-width="450" transition="dialog-bottom-transition">
      <v-card class="modern-card overflow-hidden">
        <v-toolbar flat class="bg-lightgrey border-bottom">
          <v-avatar color="primary lighten-5" size="32" class="mr-3">
            <v-icon color="primary" x-small>fas fa-envelope</v-icon>
          </v-avatar>
          <v-toolbar-title class="body-1 font-weight-black primary--text uppercase">Prueba de Envío SMTP</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="show_dialog = false">
            <v-icon small>fas fa-times</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-8">
          <div class="caption font-weight-black grey--text text-uppercase mb-4">
            Ingrese un correo electrónico para recibir el mensaje de prueba
          </div>
          <v-text-field
            v-model="email_address"
            placeholder="ejemplo@correo.com"
            outlined
            dense
            hide-details
            prepend-inner-icon="fas fa-at"
            class="modern-input"
          ></v-text-field>
          <div class="caption grey--text mt-4 italic">
            <v-icon x-small class="mr-1">fas fa-info-circle</v-icon>
            Esta acción validará las credenciales configuradas en el servidor.
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-6 bg-lightgrey d-flex justify-end shadow-sm">
          <v-btn text @click="show_dialog = false" class="grey--text font-weight-bold text-none mr-2">Cancelar</v-btn>
          <v-btn color="primary" :loading="loading" @click="test_email" class="rounded-lg px-8 font-weight-black text-none shadow-sm">
            Enviar Prueba
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { testEmail } from '@/api/parameters'
import notifications from '@/utils/notifications'

export default {
  name: 'EmailTest',
  props: {
    value: Boolean,
    email_host: String,
    email_port: String,
    email_user: String,
    email_password: String,
    email_from: String,
    email_smtp_encryption: String,
  },
  data: () => ({
    show_dialog: false,
    loading: false,
    email_address: '',
  }),
  methods: {
    async test_email() {
      if (!this.email_address) {
        notifications.showError('Ingrese un correo válido')
        return
      }
      this.loading = true
      const configuration = {
        email_host: this.email_host,
        email_port: this.email_port,
        email_user: this.email_user,
        email_password: this.email_password,
        email_from: this.email_from,
        email_smtp_encryption: this.email_smtp_encryption,
      }
      try {
        await testEmail({ to: this.email_address, configuration: configuration })
        notifications.showSuccess('Correo enviado correctamente', 'Revise su buzón de entrada para verificar la recepción.')
        this.$emit('input', true)
        this.show_dialog = false
      } catch (error) {
        notifications.showError('Error al enviar correo', error)
        this.$emit('input', false)
      } finally {
        this.loading = false
      }
    }
  },
}
</script>

<style scoped>
.modern-card { border-radius: 12px !important; }
.bg-lightgrey { background-color: #f8fbfc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.modern-input >>> .v-input__control >>> .v-input__slot {
  background-color: #f8fbfc !important;
  border-radius: 10px !important;
}
.uppercase { text-transform: uppercase; letter-spacing: 1px; }
.text-none { text-transform: none !important; }
.shadow-xs { box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.04) !important; }
.italic { font-style: italic; }
</style>